export const doublingPeriod = ({ rate }) => rate && Math.log(2) / Math.log(1 + rate);

export const fv = ({ rate, period }) => Math.pow(1 + rate, period);
